export const invertedMessages = {
  'Sorting is disabled because both Roles and Accounts are selected as top-level items in the Rows filter. To enable sorting, select only one top-level option in the filter.':
    'CERTS_SORT_DISABLED_ROLE_AND_ACC_MSG',
  'Sorting is disabled because both Roles and Entitlements are selected as top-level items in the Rows filter. To enable sorting, select only one top-level option in the filter.':
    'CERTS_SORT_DISABLED_ROLE_AND_ENT_MSG',
  'Sorting is disabled with Account and Child Entitlement':
    'CERTS_SORT_DISABLED_EO',
};
